//
//
//
//

export default {
	name: 'uni-icons',
	props: {
		/**
		 * 图标类型
		 */
		type: String,
		/**
		 * 图标颜色
		 */
		color: String,
		/**
		 * 图标大小
		 */
		size: [Number, String]
	},
	computed: {
		fontSize() {
			return `${this.size}px`
		}
	},
	methods: {
		onClick() {
			this.$emit('click')
		}
	}
}
